import { CCTVTOKEN } from "../../actions/dashboard/";

export default function(state = null, action) {
  switch (action.type) {
    case CCTVTOKEN:
      return action.payload;
    default:
  }

  return state;
}
